module.exports = __webpack_public_path__ + "static/fonts/Robotolightitalic.4561dd5.ttf";